<script setup>
import {ref, inject} from "vue";
import StartupModal from "@/views/needs/need/StartupModal.vue";

const startups = inject('solutions');

const startupModal = ref(null);

function showStartupDetails(linkId) {
    startupModal.value.open(linkId)
}
</script>

<template>
    <div>
        <header class="card-needs__header">
            <h3 class="heading3 heading3--solutions">Solutions</h3>

            <a href="#" class="link">4 Unreviewed</a>
        </header>

        <div class="card-needs__content card-needs__content--row">
            <div
                v-for="startup in startups"
                :key="startup.id"
                class="card-needs__content--col"
                @click="showStartupDetails(startup.link_id)"
            >
                <div class="card-headline">
                    <div class="card-headline__content">
                        <header class="card-headline__content__header">
                            <div class="image-block">
                                <img src="https://sp-images-dev.s3.amazonaws.com/1731059811672de0631dfad.jpeg" alt="">
                            </div>
                            <div>
                                <h5 class="heading5 heading5--secondary">{{startup.name}}</h5>
                                <p class="">Partnership Readiness: {{startup.match_score}}/10</p>
                            </div>
                        </header>

                        <p>{{startup.description}}</p>

                        <footer class="card-headline__content__footer">
                            <div class="rating-section">
                                <div class="rating">
                                    <span class="rating__current"></span>
                                    <span class="rating__current"></span>
                                    <span class="rating__current"></span>
                                    <span class="rating__current"></span>
                                    <span class=""></span>
                                </div>
                            </div>

                            <div class="card-headline__author card-headline__author--ai"></div>
                        </footer>
                    </div>
                </div>
            </div>
        </div>

        <StartupModal ref="startupModal"/>
    </div>
</template>

<style scoped>

</style>
